import React from 'react'
import {CardBox, CardTitle, Divider} from '../BaseCard/styles'
import EditIcon from '../../../../images/icons/new-dashboard/calendar-edit-icon.svg'
import {ReportLinkBox, CardText, CardContent, IconBox} from './styles'
import {Attempt} from '../../../../redux/reportExamStatus'
import {Link} from 'react-router-dom'

type Props = {
  report?: Attempt
  division: string
}

const View = ({report, division}: Props) => {
  const renderMessage = () => {
    if (report) {
      const date = new Date(report.examDate)
      date.setHours(date.getHours() + 12)
      const displayDate = date.toLocaleDateString('en-US')

      const examDate = new Date(report.examDate)
      examDate.setHours(examDate.getHours() + 12)
      const today = new Date()
      const diffInMilliseconds = examDate.getTime() - today.getTime()
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24))
      if (report.passed) {
        return (
          <>
            Congratulations
            <br />
            <span>You've passed this exam!</span>
          </>
        )
      }

      if (diffInDays > 0) {
        return (
          <>
            {diffInDays} days to go
            <br />
            <span>This exam is scheduled: {displayDate}.</span>
          </>
        )
      }

      if (diffInDays === 0) {
        return (
          <>
            How did you do?
            <br />
            <span>Your exam is sheduled for today. Good luck!</span>
          </>
        )
      }

      if (diffInDays < 0) {
        return (
          <>
            How did you do?
            <br />
            <span>
              You took this exam on {displayDate}.
              <br />
              <Link
                to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
              >
                Let us know how you did!
              </Link>
            </span>
          </>
        )
      }
    }

    return <span>Enter your scheduled exam date to start your countdown.</span>
  }

  return (
    <CardBox>
      <CardTitle>
        <span>{division} Exam Status</span>
        <ReportLinkBox>
          <Link
            to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
          >
            Report {division} Results
          </Link>
        </ReportLinkBox>
      </CardTitle>
      <Divider />
      <CardContent>
        <CardText>{renderMessage()}</CardText>
        <IconBox>
          <Link
            to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
          >
            <img src={EditIcon} alt="Edit" />
          </Link>
        </IconBox>
      </CardContent>
    </CardBox>
  )
}

export default View
